import HomeIcon from "@/resources/Eistoryboard.png";
import background from "@/resources/storyboard_background.jpg";
import { DownOutlined } from "@ant-design/icons";
import React from "react";
import { Button, Typography } from "antd";
import QueueAnim from "rc-queue-anim";
import TweenOne from "rc-tween-one";

import styles from "./styles.less";
import { Link } from "react-router-dom";

export default () => {
  return (
    <div key="storyboard-banner" className={styles.banner0} style={{ backgroundImage: `url(${background})` }}>
      <QueueAnim key="QueueAnim" type={["bottom", "top"]} delay={200} className={styles.bannerTextWrapper}>
        <div key="title" className={styles.banner0Title}>
          <Typography.Title level={1} style={{ color: "white" }}>
            Smart Invest
          </Typography.Title>
        </div>
        <div key="content" className={styles.banner0Content}>
          Creative and effective investment research platform
        </div>
        <Button ghost key="button" className={styles.banner0Button}>
          <Link to={"/dashboard"}>Getting started</Link>
        </Button>
      </QueueAnim>
      <TweenOne
        animation={{
          y: "-=20",
          yoyo: true,
          repeat: -1,
          duration: 1000
        }}
        className={styles.banner0Icon}
        key="icon"
      >
        <DownOutlined />
      </TweenOne>
    </div>
  );
};
